import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
import { ButtonBase, Box } from '@mui/material';

// project imports
import Logo from 'ui-component/Logo';
import { MENU_OPEN } from 'store/actions';

// assets
import iconPng from 'assets/images/icon.png';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
  const defaultId = useSelector((state) => state.customization.defaultId);
  const dispatch = useDispatch();
  return (
    <ButtonBase 
      disableRipple 
      onClick={() => dispatch({ type: MENU_OPEN, id: defaultId })} 
      component={Link} 
      to="/" 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px',
        textDecoration: 'none',
        color: 'inherit'
      }}
    >
      <Box
        component="img"
        src={iconPng}
        alt="Logo"
        sx={{
          height: 40,
          width: 'auto',
          borderRadius: '8px',
          objectFit: 'contain'
        }}
      />
      <Box sx={{ 
        fontSize: '20px', 
        fontWeight: 'bold', 
        letterSpacing: '-0.025em',
        lineHeight: 1.2
      }}>
        {/* Universe */}
      </Box>
    </ButtonBase>
  );
};

export default LogoSection;
